document.addEventListener('DOMContentLoaded', function () {
  var page = document.querySelector('[data-bom-page]');
  if (!page) return;

  var cards = Array.prototype.slice.call(page.querySelectorAll('[data-bom-card]'));
  var refresh = page.querySelector('[data-bom-refresh]');

  function shuffle(items) {
    var copy = items.slice();
    for (var i = copy.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }
    return copy;
  }

  function showProjects() {
    cards.forEach(function (card) { card.hidden = true; });
    shuffle(cards).slice(0, 4).forEach(function (card) { card.hidden = false; });
  }

  if (cards.length) showProjects();
  if (refresh) refresh.addEventListener('click', showProjects);

  page.querySelectorAll('a[href="#bom-products"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.getElementById('bom-products');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});
